import { render, staticRenderFns } from "./SchedulePolicyForm.vue?vue&type=template&id=e36dad06"
import script from "./SchedulePolicyForm.vue?vue&type=script&lang=js"
export * from "./SchedulePolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports